module.exports = __webpack_public_path__ + "img/jpyCard.cf2a86c4.jpg";